import React from 'react';
import { createRoot } from 'react-dom/client';
import { LoginRouter } from '@js/routes/index';

createRoot(document.getElementById('login')).render(<LoginRouter />);
